export default class {
  constructor({
    handle,
    modalSelector,
    maskSelector,
    modalContent,
    triggerSelector,
    closeSelector
  }) {
    const modal = document.querySelector(modalSelector);
    const mask = document.querySelector(maskSelector);
    const triggers = document.querySelectorAll(triggerSelector);
    const closeTrigger = modal.querySelector(closeSelector);
    const modalContents = modalContent;
    const baseModalImgSrc = '/assets/vms/dist/images/performance/modal/';

    const modalTitleEl = modal.querySelector('.js-title');
    const modalCopyEl = modal.querySelector('.js-copy');
    const modalDetailBody = modal.querySelector('.js-detail-body');

    /**
     * Function for creating details within performance modal
     */
    const createDetails = (parent, details) => {
      details.forEach(detail => {
        // create the elements
        let detailWrapper = document.createElement('div');
        let detailTitle = document.createElement('p');
        let detailCopy = document.createElement('p');

        detailWrapper.classList.add('detail__wrapper');

        // add the class and contents
        if (detail.title !== undefined) {
          detailTitle.classList.add('detail__title');
          detailTitle.innerHTML = detail.title;
          detailWrapper.appendChild(detailTitle);
        }
        if (detail.copy !== undefined) {
          detailCopy.classList.add('detail__copy');
          detailCopy.innerHTML = detail.copy;
          detailWrapper.appendChild(detailCopy);
        }

        // TODO: Use arrays as default for img_url, loop through always and remove if statement
        /**
         * Need to see if the detail has multiple images
         * create a List variable, if it's of type object (array)
         * loop through and create each image element needed.
         * If it's not an object (array), there was only 1 img_url
         */
        let detailImgList = detail.img_url;

        if (typeof detailImgList == 'object') {
          detailImgList.forEach(imgUrl => {
            let detailImage = document.createElement('img');

            detailImage.src = baseModalImgSrc + imgUrl;
            detailImage.classList.add('detail__img');
            detailWrapper.appendChild(detailImage);
          });
        } else {
          let detailImage = document.createElement('img');

          detailImage.src = baseModalImgSrc + detail.img_url;
          detailImage.classList.add('detail__img');
          detailWrapper.appendChild(detailImage);
        }

        // Finally append the created detail to the parent
        parent.appendChild(detailWrapper);
      });
    }

    /**
     * Function to destroy the details content
     */
    const destroyDetails = (parent) => {
      let detailChildren = Array.from(parent.children);
      // No need for additional conditional
      if (detailChildren.length > 0) {
        while (parent.firstChild) {
          parent.removeChild(parent.firstChild);
        }
      }
    }

    /**
     * Function for opening the modal
     *
     * @param {object} e
     */
    const openModal = (e, trigger) => {
      e.preventDefault();
      let contentSlug = e.currentTarget.getAttribute('data-target').replace(/\s+/g, '_'); // Replace spaces with underscores
      contentSlug = contentSlug.replace(/\-/g, '_'); // Replace hyphens with underscores
      const targetContent = modalContents[contentSlug];
      const contentDetails = targetContent.details;

      if (targetContent == undefined) {
        return
      }

      modalTitleEl.innerHTML = targetContent.title;
      modalCopyEl.innerHTML = targetContent.copy;

      // Destroy old details destroyDetails(modalDetailBody);
      // TODO: remove destroyDetails and simply innerHTML = ''
      destroyDetails(modalDetailBody);
      // Create new details, if there are any
      if (contentDetails !== undefined) {
        createDetails(modalDetailBody, contentDetails);
      }

      // Grab the modal direction data attribute
      const modalDirection = trigger.getAttribute('data-modal-direction');

      // Determine the top offset of the parent section of the CTA
      const triggerOffset = trigger.parentNode.getBoundingClientRect().top + window.scrollY;
      const sectionOffset = triggerOffset - 135;

      // Execute scroll body then show modal and masks
      scrollBody(modal, mask, sectionOffset, modalDirection);

    }


    /**
     * Function for scrolling window to where this section is at top aligned with modal copy
     */
    function scrollBody(modal, mask, sectionOffset, modalDirection) {
      if (modalDirection && modalDirection === 'left') {
        modal.classList.add('is--left');
        setTimeout(() => {
          modal.classList.add('active');
          mask.classList.add('active');
          window.scroll(0, sectionOffset);
          // Now add noscroll class
          document.body.classList.add('noscroll');
        }, 200);
      } else {
        modal.classList.add('active');
        mask.classList.add('active');
        window.scroll(0, sectionOffset);
        // Now add noscroll class
        document.body.classList.add('noscroll');
      }
    }


    /**
     * Function for closing the modal
     */
    const closeModal = () => {
      document.body.classList.remove('noscroll');
      modal.classList.remove('active');
      setTimeout(() => {
        modal.classList.remove('is--left', 'is--right');
        mask.classList.remove('active');
      }, 200);
    }

    /**
     * Event Listeners
     */
    Array.from(triggers).forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        openModal(e, trigger);
      });
    })

    closeTrigger.addEventListener('click', () => {
      closeModal();
    });

    /**
     * Listen to the escape key being pressed. Close the modal if it was pressed AND the modal is active
     * Do the same if someone clicks on the mask.
     */
    window.addEventListener('keypress', e => {
      if (e.key === 'Escape' && modal.classList.contains('active'))
        closeModal();
    });

    mask.addEventListener('click', () => {
      closeModal();
    });
  }
}